import type { TranslationMessages } from '../../types';

export const shift_bonus_config = 'Cấu hình thưởng ca';
export const shift_bonus_config_desc = 'Cấu hình thưởng cho các ca làm việc';

export const bonus_config: TranslationMessages = {
  title: 'Cấu hình thưởng ca',
  description:
    'Cấu hình thưởng cho các loại ca khác nhau. Thưởng có thể dựa trên vị trí, thời gian trong ngày hoặc ngày trong tuần.',
  add_config: 'Thêm cấu hình',
  edit_config: 'Chỉnh sửa cấu hình thưởng',
  config_name: 'Tên cấu hình',
  config_name_placeholder: 'ví dụ: Thưởng cuối tuần',
  position: 'Vị trí',
  all_positions: 'Tất cả vị trí',
  time_of_day: 'Thời gian trong ngày',
  any_time: 'Bất kỳ thời gian nào',
  morning: 'Sáng',
  afternoon: 'Chiều',
  evening: 'Tối',
  night: 'Đêm',
  days_of_week: 'Ngày trong tuần',
  sunday: 'Chủ Nhật',
  monday: 'Thứ Hai',
  tuesday: 'Thứ Ba',
  wednesday: 'Thứ Tư',
  thursday: 'Thứ Năm',
  friday: 'Thứ Sáu',
  saturday: 'Thứ Bảy',
  all_days_selected: 'Để trống cho tất cả các ngày',
  bonus_amount: 'Số tiền thưởng',
  currency: 'Tiền tệ',
  description_label: 'Mô tả',
  description_placeholder: 'Mô tả tùy chọn',
  conditions: 'Điều kiện',
  bonus: 'Thưởng',
  status: 'Trạng thái',
  active: 'Hoạt động',
  inactive: 'Không hoạt động',
  actions: 'Hành động',
  cancel: 'Hủy',
  save: 'Lưu',
  loading: 'Đang tải...',
  load_error: 'Không thể tải cấu hình thưởng',
  save_success: 'Lưu cấu hình thưởng thành công',
  save_error: 'Không thể lưu cấu hình thưởng',
  validation_error: 'Vui lòng điền vào tất cả các trường bắt buộc',
  delete_title: 'Xóa cấu hình thưởng',
  delete_confirm:
    'Bạn có chắc chắn muốn xóa cấu hình này không? Hành động này không thể hoàn tác.',
  delete: 'Xóa',
  no_configs:
    'Không tìm thấy cấu hình thưởng nào. Thêm một cấu hình để bắt đầu.',
  all_shifts: 'Tất cả ca làm việc',
  weekend_bonus: 'Thưởng cuối tuần',
  weekend_bonus_desc: 'Thưởng cho việc làm việc vào cuối tuần',
  night_shift_bonus: 'Thưởng ca đêm',
  night_shift_bonus_desc: 'Thưởng cho ca đêm',
  custom_time: 'Phạm vi thời gian tùy chỉnh',
  custom_time_range: 'Phạm vi thời gian tùy chỉnh',
  start_time: 'Thời gian bắt đầu',
  end_time: 'Thời gian kết thúc',
  custom_time_hint:
    'Đặt phạm vi thời gian cho khoản thưởng này. Các ca làm việc bắt đầu trong phạm vi này sẽ nhận được khoản thưởng.',
};
